import type { FaireProductEntity } from "../../entity_types/product";

export const p_rbtxc2mh5a: FaireProductEntity = {
  token: "p_rbtxc2mh5a",
  type: "product",
  name: "Moroccan Beni Ourain Rug-Contemporary Moroccan Wool Carpet",
  brandToken: "b_7ynhfn3ztz",
  brandName: "woolsouk ( We handle U.S. import procedures for you )",
  imageUrl:
    "https://cdn.faire.com/fastly/f2b969600475fa81ff9d3a82df8879801d7181ce312a4de653cb617fab5c1e63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f2cf2d5d427eefd85bde57b87d6d33a60080248456f5ea6d4e8cf430ff9b955.jpeg",
    "https://cdn.faire.com/fastly/53e6508a995d4d7b605d064985ffa33a47e2079b777856c84478a6cdcb029824.png",
    "https://cdn.faire.com/fastly/90931ce96abd9d20cfa97b9fab39d8331d79c75f4a25987b5def04c227ea20f0.png",
    "https://cdn.faire.com/fastly/a34a04333a0182849852f5615cf1f7544072f28e6703b5e055897fd3f6ceeaa0.webp",
  ],
  priceDollars: 205.67,
  description:
    "-Note 1 : The time to preapre a custom  rug is 6-8 weeks\n-Note 2 ; if you want specific size, please feel free to contact us, we are willing to weave your custom rugs.\nThis stunning Moroccan Beni Ourain rug is a true work of art, handcrafted by skilled Berber artisans. The rug features a classic geometric pattern in a soft, neutral color palette . The intricate details and unique design make this rug a one-of-a-kind piece.\n\nThis rug is not only a beautiful addition to your home decor but also a valuable heirloom. It can be used in various settings, such as living rooms, bedrooms, or dining areas, adding a touch of bohemian elegance and cultural richness\nMoroccan rug, Azilal rug, Berber rug, vintage rug, handmade rug, geometric pattern, red and white rug, bohemian decor, Moroccan home decor.\n\n",
  tags: [],
  msrpDollars: 411.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:07.668Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
